import { Component, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { PaymentIqComponent } from 'src/app/pages/wallet/payment-iq/payment-iq.component';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CustomizeFormModule } from 'src/app/shared/components/customize-form/customize-form.module';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PaymentIQData } from 'src/app/shared/interfaces/deposit.interface';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { CardDepositService } from './card-deposit.service';

@UntilDestroy()
@Component({
  selector: 'app-card-deposit',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CSButtonComponent,
    CustomizeFormModule,
    PipesModule,
    PipesModule,
    LoadingModule,
    PaymentIqComponent,
    CSIconButtonComponent,
  ],
  templateUrl: './card-deposit.component.html',
  styleUrl: './card-deposit.component.scss',
})
export class CardDepositComponent implements OnInit {
  constructor(
    public cardDepositService: CardDepositService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: PaymentIQData,
  ) {}

  ngOnInit(): void {
    this.initData(this.data);
  }

  initData(data: PaymentIQData) {
    if (!data) {
      return;
    }
  }

  /**
   * 返回購買加密貨幣錢包頁面
   */
  goBackBuyCryptoWallet() {
    this.cardDepositService.closeCardModal();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        dialog: 'wallet',
        tab: 'deposit',
        subTab: 'buyCrypto',
      },
    });
  }

  /**
   * 聯絡客服
   */
  contactSupport() {
    this.appService.toOnLineService$.next(true);
  }
}
